export default __webpack_public_path__ + "static/media/44.a11a727f.png";